import React from 'react';
import UserVendorCreateContract from './UserVendorCreateContract';

const UserVendorEditContract = () => {
  return <UserVendorCreateContract isEdit={true} />;
};

export default UserVendorEditContract;


